import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M6.08926 1.92259C6.41469 1.59715 6.41469 1.06951 6.08926 0.744078C5.76382 0.418641 5.23618 0.418641 4.91074 0.744078L0.744078 4.91074C0.418641 5.23618 0.418641 5.76382 0.744078 6.08926C1.06951 6.41469 1.59715 6.41469 1.92259 6.08926L6.08926 1.92259Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M9.91074 1.92259C9.58531 1.59715 9.58531 1.06951 9.91074 0.744078C10.2362 0.418641 10.7638 0.418641 11.0893 0.744078L15.2559 4.91074C15.5814 5.23618 15.5814 5.76382 15.2559 6.08926C14.9305 6.41469 14.4028 6.41469 14.0774 6.08926L9.91074 1.92259Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M4.66667 7.93245C5.1269 7.93245 5.5 8.30555 5.5 8.76579V11.2658C5.5 11.726 5.1269 12.0991 4.66667 12.0991C4.20643 12.0991 3.83333 11.726 3.83333 11.2658V8.76579C3.83333 8.30555 4.20643 7.93245 4.66667 7.93245Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M11.3333 7.93245C11.7936 7.93245 12.1667 8.30555 12.1667 8.76579V11.2658C12.1667 11.726 11.7936 12.0991 11.3333 12.0991C10.8731 12.0991 10.5 11.726 10.5 11.2658V8.76579C10.5 8.30555 10.8731 7.93245 11.3333 7.93245Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  d: "M8 7.93245C8.46024 7.93245 8.83333 8.30555 8.83333 8.76579V11.2658C8.83333 11.726 8.46024 12.0991 8 12.0991C7.53976 12.0991 7.16667 11.726 7.16667 11.2658V8.76579C7.16667 8.30555 7.53976 7.93245 8 7.93245Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.33333 4.66667C0.873096 4.66667 0.5 5.03976 0.5 5.5V13C0.5 14.3807 1.61929 15.5 3 15.5H13C14.3807 15.5 15.5 14.3807 15.5 13V5.5C15.5 5.03976 15.1269 4.66667 14.6667 4.66667H1.33333ZM2.16667 13V6.33333H13.8333V13C13.8333 13.4602 13.4602 13.8333 13 13.8333H3C2.53976 13.8333 2.16667 13.4602 2.16667 13Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7
  ]))
}